import React, { useState, useEffect } from "react";
import { Table, Image } from "react-bootstrap";
import BasicPagination from "../../../../Pagination/Pagination";
import moment from "moment";
import isEmpty from "../../../../../store/validation/is-Empty";
import { NOTAVAILABLEIMAGE } from "../../../../../enums/GlobalEnums";

const NominationPageComponent = (props) => {
  //state
  const [page, setPage] = useState(1);
  const [start, setStart] = useState(0);
  const [end, setEnd] = useState(10);
  const handleBatchChange = (pageNo) => {
    window.scrollTo(0, 0);
    var calcStart = pageNo * 10 - 10;
    setStart(calcStart);
    setEnd(pageNo * 10);
    setPage(pageNo);
  };

  let filteredData = props.data;

  if (props.search) {
    filteredData = filteredData.filter((item) => {
      return (
        (item &&
          item.name &&
          item.name.toLowerCase().includes(props.search.toLowerCase())) ||
        (item &&
          item.place_id &&
          item.place_id.toLowerCase().includes(props.search.toLowerCase()))
      );
    });
  }

  if (props.sortBy === "Date & Time 🠑") {
    filteredData = filteredData?.sort(
      (a, b) => new Date(b.updatedAt) - new Date(a.updatedAt)
    );
  } else if (props.sortBy === "Date & Time 🠓") {
    filteredData = filteredData?.sort(
      (a, b) => new Date(a.updatedAt) - new Date(b.updatedAt)
    );
  } else if (props.sortBy === "A-Z") {
    filteredData = filteredData?.sort((a, b) => (a.name > b.name ? 1 : -1));
  } else if (props.sortBy === "Z-A") {
    filteredData = filteredData?.sort((a, b) => (b.name > a.name ? 1 : -1));
  }

  if (props.filterBy) {
    if (props?.filterBy?.value)
      filteredData = filteredData?.filter((ele) =>
        ele.vicinity.split(" ").slice(-1)[0]
          ? ele.vicinity
              .split(" ")
              .slice(-1)[0]
              .toLowerCase()
              .includes(props.filterBy?.value.toLowerCase())
          : false
      );
  }

  useEffect(() => {
    // setSortBy("");
    // setSortName([]);
    setPage(1);
    setStart(0);
    setEnd(10);
  }, [props.search]);
  return (
    <>
      <div className="col-12 p-0 user-table-reusable-superadmin table-responsive ">
        <Table className="enMinWidth900">
          <thead>
            <tr className="super_admin_all_users_table_head">
              <th style={{ width: "16.66%" }} className="f12-700">
                Restaurant
              </th>
              <th style={{ width: "16.66%" }} className="f12-700">
                Location
              </th>
              <th style={{ width: "16.66%" }} className="f12-700">
                Date/Time
              </th>
              <th style={{ width: "33.33%" }} className="f12-700">
                Google place ID
              </th>
              {/* <th style={{ width: "16.66%" }} className="f12-700">
                On-Boarded
              </th> */}
            </tr>
          </thead>
          <tbody className="HideShowTable">
            {filteredData.slice(start, end).map((item, index) => (
              <tr
                className="super_admin_all_users_table_body super_admin_user_view_inside_table_body"
                key={index}
              >
                <td style={{ width: "16.66%" }}>
                  <div className="d-flex flex-column align-items-start">
                    <div className="enImage45 ">
                      <Image
                        //src={require("../../../../../assets/images/UserManagement/fhr7.png")}
                        src={item.icon || NOTAVAILABLEIMAGE}
                        alt="View"
                        title="View"
                        fluid
                      />
                    </div>
                    <div className="f11-500 text-center mt-1">{item.name}</div>
                  </div>
                </td>
                <td style={{ width: "16.66%" }}>
                  <div className="f15-400">
                    {item.vicinity.split(" ").slice(-1)[0]}
                  </div>
                </td>
                <td style={{ width: "16.66%" }}>
                  {/* <div className="f15-500">25th Aug, 2020</div> */}
                  <div className="f15-400">
                    {moment(item.updatedAt).format("Do MMM, YYYY")}{" "}
                  </div>
                  <div className="f15-400">
                    {moment(item.updatedAt).format("h:mm a")}
                  </div>
                </td>
                <td style={{ width: "33.33%" }}>
                  <div className="f13-400">{item.place_id}</div>
                </td>
                {/* <td style={{ width: "16.66%" }}>
                  <div className="f15-400">
                    {item.status === true ? <>Yes </> : <> No</>}
                  </div>
                </td> */}
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
      {filteredData.length !== 0 ? (
        <BasicPagination
          totalRecords={filteredData.length}
          limit={10}
          batch={page}
          onBatchChange={(e) => handleBatchChange(e)}
        />
      ) : (
        <></>
      )}
    </>
  );
};

export default NominationPageComponent;
